// Required enums for models
export enum BookingStatus {
  PENDING = 'PENDING',
  FAILED = 'FAILED',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  EXTENDED = 'EXTENDED'
}
export enum RideStatus {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  ENDED = 'ENDED'
}
export enum BookingType {
  STANDARD = 'STANDARD',
  SUBSCRIPTION = 'SUBSCRIPTION'
}
export enum BillingCycle {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  FIFTEEN_DAYS = 'FIFTEEN_DAYS',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY'
}
export enum SubscriptionInvoiceStatus {
  PENDING = 'PENDING',
  PAID = 'PAID',
  OVERDUE = 'OVERDUE'
}
export enum AccessoryType {
  DAILY = 'DAILY',
  TRIP = 'TRIP'
}
export enum OfferType {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT',
  GBK_COMMISSION_PERCENT = 'GBK_COMMISSION_PERCENT',
  FREE_KMS = 'FREE_KMS',
  FREE_ACCSSORY = 'FREE_ACCSSORY',
  GO_COINS = 'GO_COINS'
}
export enum OrderMode {
  USER = 'USER',
  VENDOR = 'VENDOR',
  ADMIN = 'ADMIN'
}
export enum PaymentMode {
  ONLINE = 'ONLINE',
  PARTIAL = 'PARTIAL',
  OFFLINE = 'OFFLINE'
}
export enum SettlementStatus {
  PG_SETTLEMENT_PENDING = 'PG_SETTLEMENT_PENDING',
  READY_FOR_SETTLEMENT = 'READY_FOR_SETTLEMENT',
  INITIATED_SETTLEMENT = 'INITIATED_SETTLEMENT',
  SETTLED = 'SETTLED'
}
export enum EngineType {
  E_BIKE = 'E_BIKE',
  MOTOR = 'MOTOR',
  CNG = 'CNG',
  PETROL = 'PETROL',
  CNG_PETROL = 'CNG_PETROL',
  DIESEL = 'DIESEL',
  ELECTRIC_PETROL = 'ELECTRIC_PETROL',
  ELECTRIC_DIESEL = 'ELECTRIC_DIESEL',
  ELECTRIC_ONLY = 'ELECTRIC_ONLY'
}
export enum StartingMethod {
  KICK = 'KICK',
  AUTO = 'AUTO'
}
export enum TransmissionType {
  GEAR = 'GEAR',
  GEARLESS = 'GEARLESS',
  IMT = 'IMT'
}
export enum HubBikeDiscountType {
  FLAT = 'FLAT',
  PERCENT = 'PERCENT'
}
export enum IdType {
  AADHAR = 'AADHAR',
  PASSPORT = 'PASSPORT',
  VOTER = 'VOTER',
  DL = 'DL',
  PAN = 'PAN'
}
interface IdInfo {
  type: IdType;
  number: string;
  photo: string;
}
export enum VendorType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY'
}
export enum CompanyType {
  LLP = 'LLP',
  PVT_LTD = 'PVT_LTD',
  OPC = 'OPC',
  OTHERS = 'OTHERS'
}
export interface CompanyInfo {
  type: CompanyType;
  name: string;
  address: string;
  gst?: string;
}
export enum TimeZones {
  INDIA = 'Asia/Kolkata',
  SINGAPORE = 'Asia/Singapore'
}
export enum CalculationType {
  DAILY = 'DAILY',
  HOURLY = 'HOURLY'
}
export enum VendorPaymentMode {
  PREPAID_ONLY = 'PREPAID_ONLY',
  POSTPAID_ONLY = 'POSTPAID_ONLY',
  OFFLINE_ONLY = 'OFFLINE_ONLY',
  PREPAID_AND_POSTPAID = 'BOTH',
  PREPAID_AND_OFFLINE = 'PREPAID_AND_OFFLINE',
  POSTPAID_AND_OFFLINE = 'POSTPAID_AND_OFFLINE',
  ALL_ONLINE_AND_OFFLINE = 'ALL_ONLINE_AND_OFFLINE'
}
export enum VendorOrderMode {
  USER_AND_ADMIN = 'USER_AND_ADMIN',
  ALL = 'ALL'
}
export interface CalculationBasis {
  calcType: CalculationType;
  dayStart?: number;
  dayEnd?: number;
}
export enum VehicleType {
  BIKE = 'BIKE',
  CAR = 'CAR'
}
export enum HubBikeUploadLabels {
  FRONT = 'FRONT',
  BACK = 'BACK',
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  TYRE = 'TYRE',
  ENGINE = 'ENGINE',
  ODOMETER = 'ODOMETER'
}
export enum OrderUploadLabels {
  CUSTOMER = 'CUSTOMER',
  BIKE_LEFT = 'BIKE_LEFT',
  BIKE_RIGHT = 'BIKE_RIGHT',
  BIKE_FRONT = 'BIKE_FRONT',
  BIKE_BACK = 'BIKE_BACK',
  ODOMETER = 'ODOMETER',
  OTHER = 'OTHER',
  EXTRA_1 = 'EXTRA_1',
  EXTRA_2 = 'EXTRA_2'
}
export type HubBikeImageUploads = { [k in HubBikeUploadLabels]?: string }
export enum HubBikePerQuantityUploadLabels {
  RC = 'rcPhoto',
  INSURANCE = 'insurancePhoto',
  POLLUTION = 'pollutionPhoto',
}
export type HubBikePerQuantityImageUploads = { [k in HubBikePerQuantityUploadLabels]?: string }
export enum UploadFileType {
  JPG = 'JPG',
  WEBP = 'WEBP',
  PNG = 'PNG'
}
export enum LedgerType {
  MANUAL_CREDIT = 'MANUAL_CREDIT',
  MANUAL_DEBIT = 'MANUAL_DEBIT',
  ORDER_SETTLEMENT = 'ORDER_SETTLEMENT'
}
export enum CronTaskType {
  VENDOR_CREDIT = 'VENDOR_CREDIT',
  VENDOR_DEBIT = 'VENDOR_DEBIT',
  USER_REFUND = 'USER_REFUND'
}
export enum CronTaskStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  ON_HOLD = 'ON_HOLD',
  FINISHED = 'FINISHED',
  FAILED = 'FAILED'
}
export enum PricePackages {
  YEARLY = 'fullYear',
  HALF_YEARLY = 'halfYear',
  QUARTER_YEARLY = 'quarterYear',
  MONTHLY = 'month',
  FORTNIGHTLY = 'fortnight',
  WEEKLY = 'week',
  DAILY = 'fullDay',
  TRIP = 'trip',
  QUARTER_DAY = 'quarterDay',
  EIGHTH_DAY = 'eighthDay'
}
export enum PricePackageUnits {
  HOUR_UNIT = 'HOUR',
  DAY_UNIT = 'DAY',
  HALF_DAY_UNIT = 'HALF_DAY',
  WEEKDAY_UNIT = 'WEEKDAY',
  WEEKEND_UNIT = 'WEEKEND',
  TRIP_UNIT = 'TRIP'
}
export enum AccessoryPricePackages {
  YEARLY = 'fullYear',
  HALF_YEARLY = 'halfYear',
  QUARTER_YEARLY = 'quarterYear',
  MONTHLY = 'month',
  FORTNIGHTLY = 'fortnight',
  WEEKLY = 'week',
  DAILY = 'fullDay',
  QUARTER_DAY = 'quarterDay',
  EIGHTH_DAY = 'eighthDay',
  TRIP = 'trip'
}
export enum OrderRefundStatus {
  PENDING = 'PENDING',
  ONHOLD = 'ONHOLD',
  CANCELLED = 'CANCELLED',
  SUCCESS = 'SUCCESS',
  NOT_REQUIRED = 'NOT_REQUIRED'
}
export enum OrderRefundType {
  PAYMENT_AUTO_REFUND = 'PAYMENT_AUTO_REFUND',
  MERCHANT_INITIATED = 'MERCHANT_INITIATED',
  UNRECONCILED_AUTO_REFUND = 'UNRECONCILED_AUTO_REFUND'
}
export enum ReviewStates {
  NEW = 'NEW',
  APPROVED = 'APPROVED',
  ABUSIVE = 'ABUSIVE',
  REJECTED = 'REJECTED'
}
export enum OrderEvent {
  PLACED = 'PLACED',
  PAYMENT = 'PAYMENT',
  EXTENDED = 'EXTENDED',
  CANCELLED = 'CANCELLED',
  EDITED = 'EDITED',
  VEHICLE_UPDATED = 'VEHICLE_UPDATED',
  AMOUNT_UPDATED = 'AMOUNT_UPDATED',
  RIDE_START = 'RIDE_START',
  RIDE_END = 'RIDE_END',
  RESCHEDULED = 'RESCHEDULED',
  PAYMENT_LINK = 'PAYMENT_LINK',
  CUSTOM_PAYMENT_LINK = 'CUSTOM_PAYMENT_LINK',
  OFFLINE_PAYMENT = 'OFFLINE_PAYMENT',
  DAMAGE_INVOICE = 'DAMAGE_INVOICE',
  INVOICE_GENERATED = 'INVOICE_GENERATED',
  TICKET_CREATED = 'TICKET_CREATED',
  TICKET_CLOSED = 'TICKET_CLOSED',
  FUTURE_PICKUP_REMARK = 'FUTURE_PICKUP_REMARK'
}
export type CustomTrailFields = 'link' | 'before' | 'after' | 'paymentTypes' | 'createdBy' | 'closedBy';

export interface HubBikeDiscount {
  value: number;
  discountType: HubBikeDiscountType;
  maxValue?: number;
}

export interface PackageAvailability {
  hour?: boolean;
  eighthDay?: boolean;
  quarterDay?: boolean;
  halfDay?: boolean;
  fullDay?: boolean;
  week?: boolean;
  fortnight?: boolean;
  month?: boolean;
  quarterYear?: boolean;
  halfYear?: boolean;
  fullYear?: boolean;
}

export interface PackageValues {
  hour?: number;
  eighthDay?: number;
  quarterDay?: number;
  halfDay?: number;
  fullDay?: number;
  week?: number;
  fortnight?: number;
  month?: number;
  quarterYear?: number;
  halfYear?: number;
  fullYear?: number;
}

export interface BikeAvailability {
  hour?: boolean;
  eighthDay?: boolean;
  quarterDay?: boolean;
  halfDay?: boolean;
  fullDay?: boolean;
  week?: boolean;
  weekEnd?: boolean;
  fortnight?: boolean;
  month?: boolean;
  quarterYear?: boolean;
  halfYear?: boolean;
  fullYear?: boolean;
}

export interface OneBike {
  documentVerifed: boolean;
  rcNumber: string;
  rcPhoto?: string;
  insurancePhoto?: string;
  pollutionPhoto?: string;
  mfdYear: number;
  odometer: number;
  odometerLastUpdatedAt?: number;
  lastServiced?: number;
  fastTag?: boolean;
  newUploads: HubBikePerQuantityImageUploads
  used?: boolean; // Custom field for front-end use
}

export interface HubBikeDiscount {
  value: number;
  discountType: HubBikeDiscountType;
  maxValue?: number;
}

export interface BikePenalty {
  late?: number;
  distance?: number;
}

export interface KmPackage {
  extraKm: number;
  charge: number;
}

export interface BikePrice {
  hour?: number;
  eighthDay?: number;
  quarterDay?: number;
  halfDay?: number;
  fullDay?: number;
  weekEnd?: number;
  week?: number;
  fortnight?: number;
  month?: number;
  quarterYear?: number;
  halfYear?: number;
  fullYear?: number;
}

export interface BikeDetail {
  odStart?: number;
  odEnd?: number;
  rcNumber: string;
}

export interface AccessoryAvailability extends PackageAvailability {
  trip?: boolean;
}
export interface AccessoryPrice extends PackageValues {
  trip?: number;
}

export interface OrderStaticData {
  distanceLimit: number;
  priceBreakdown?: OrderBikePriceBreakdown[];
  deliveryCharges?: DeliveryCharges;
  penalty?: BikePenalty;
  finalPenalties?: {
    type: keyof BikePenalty,
    factor: number
    amount: number
  }[];
}

export interface OrderBikePriceBreakdown {
  package: PricePackages;
  unitName: PricePackageUnits;
  unitPrice: number;
  unitQty: number;
  quantity: number;
  amount: number;
  surged?: boolean;
}

export interface DeliveryCharges {
  upto05?: number;
  upto10?: number;
  upto20?: number;
}

export interface CityModel {
  id: number;
  countryId: number;
  name: string;
  active: boolean;
  vendors?: VendorModel[];
}

export interface VendorModel {
  id: number;
  cityId: number;
  regStatus: boolean;
  activeStatus: boolean;
  adminBlocked: boolean;
  profileLocked: boolean;
  certifiedDealer?: boolean;
  mandatoryPickupPhotos?: boolean;
  mandatoryEmContact?: boolean;
  name: string;
  username: string;
  company: string;
  phone: string;
  otherPhone?: string;
  email: string;
  otherEmail?: string;
  idInfo?: IdInfo;
  pan?: IdInfo;
  vendorType: VendorType;
  companyInfo?: CompanyInfo;
  timezone: TimeZones;
  onInterakt?: boolean;
  noCustomerNotifications?: boolean;
  subscriptionEnabled?: boolean;
  split: number;
  priceCalculation: CalculationBasis;
  onCashfree: boolean;
  bankName?: string;
  bankIfsc?: string;
  accountHolder?: string;
  accountNumber?: string;
  accountVerified: boolean;
  hubs?: HubModel[];
  coupons?: CouponModel[];
  city?: CityModel;
  cashfreeData?: CashfreeVendorModel;
  paymentMode: VendorPaymentMode,
  orderMode: VendorOrderMode
}

export interface CashfreeVendorModel {
  name: string;
  email: string;
  phone: string;
  settlementCycleId: string;
  bank: {
    accountNumber: string;
    accountHolder: string;
    ifsc: string;
  };
  status?: 'ACTIVE' | 'BLOCKED';
  balance: number;
  nextSettlementDetails: {
    date: string,
    settlementAmount: number
  }
}

export interface CashfreeVendorLedger {
  settlementId: number;
  totalTransactionAmount: number;
  totalAdjustmentAmount: number;
  settlementServiceCharge: number;
  settlementServiceTax: number;
  settlementAmount: number;
  status: string;
  initiatedOn: string;
  updatedOn: string;
  utr: string;
}

export interface HubDiscountModel {
  value: number;
  discountType: HubBikeDiscountType;
  maxValue?: number;
  minOrder?: number;
}
export interface HubModel {
  id: number;
  vendorId: number;
  vendorActive: boolean;
  adminActive: boolean;
  regStatus: boolean;
  inventoryLocked?: boolean;
  phone: string;
  otherPhone: string;
  email: string;
  otherEmail: string;
  landmark: string;
  latitude: number;
  longitude: number;
  fullAddress: string;
  howToReach: string;
  neighbourhood: string;
  opStart: number;
  opEnd: number;
  minDuration: number;
  deliveryMinDays: number;
  discount?: HubDiscountModel;
  delivery: boolean;
  deliveryCharges?: DeliveryCharges;
  deliveryStartTime?: number;
  deliveryEndTime?: number;
  customerImages?: string[];
  tnc: string[];
  closingDays?: number[];
  hub_bikes?: HubBikeModel;
}

export interface CouponModel {
  id: number;
  code: string;
  active: boolean;
  scope: 'VENDOR' | 'GLOBAL';
  title: string;
  description: string;
  minOrder: number;
  minDays: number;
  maxAmount?: number;
  offerType: OfferType;
  vendorShare?: number;
  value?: number;
  accessoryId?: number;
  offerStart: number;
  offerEnd: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CashfreePayment {
  cf_payment_id: string;
  order_id: string;
  payment_amount: string;
  payment_currency: string;
  payment_status: string;
  payment_message: string;
  bank_reference: string;
  auth_id: string;
  payment_method: {
    [method: string]: { [k: string]: string }
  };
}

export interface CashfreeRefund {
  cf_payment_id: number;
  cf_refund_id: string;
  refund_id: string;
  order_id: string;
  entity: 'refund';
  refund_amount: number;
  refund_currency: string;
  refund_note: string;
  refund_status: OrderRefundStatus;
  refund_type: OrderRefundType;
  refund_splits: {
    vendor_id: string;
    amount: number;
    percentage: number;
  }[];
  status_description: string;
  refund_arn: string;
  metadata: any;
  created_at: string;
  processed_at: string;
  refund_charge: number;
  refund_mode: string;
}

export interface OrderRefundAmounts {
  customerRefundAmount: number;
  vendorRefundSplitAmount: number;
  vendorDebitAmount: number;
  vendorCreditAmount: number;
}

export interface OrderCancelDetails {
  reason: string;
  comment?: string;
}

interface ReputeAttribute {
  doc?: { [k: string]: string }; value?: string; verified?: boolean;
}
export interface ReputeAttributes {
  aadhar?: ReputeAttribute;
  dl?: ReputeAttribute;
  address?: ReputeAttribute;
  latestPic?: ReputeAttribute;
}

export interface BikeModel {
  id: number;
  brand: string;
  name: string;
  image: string;
  vehicleType: VehicleType;
  mileage: number;
  topSpeed: number;
  displacement?: number;
  fuelTankCapacity?: number;
  kerbWeight?: number;
  engineType: EngineType;
  startingMethod?: StartingMethod;
  transmission?: TransmissionType;
  removableBattery?: boolean;
  hubs?: HubModel[];
  hub_bikes?: HubBikeModel;
  order_bikes?: OrderBikeModel
}

export interface HubBikeModel {
  id?: number;
  hubId?: number;
  bikeId?: number;
  prices: BikePrice;
  deposit: number;
  discount?: HubBikeDiscount;
  vendorActive?: boolean;
  adminActive?: boolean;
  availability: BikeAvailability;
  quantity: number;
  activeQuantity: number;
  bikes: OneBike[];
  imageData?: { [k in HubBikeUploadLabels]?: string };
  distanceLimits: { [k in keyof BikePrice]: number };
  speedLimit: number;
  penalty: BikePenalty;
  kmPackages?: KmPackage[];
  tnc: string[];
  hub_bikes_overrides?: HubBikeOverrideModel[];
  dynamicPrice?: number;
  dynamicDiscount?: number;
  dynamicQuantity?: number;
  dynamicRating?: number;
  dynamicRatingCount?: number;
  bike?: BikeModel;
  hub?: HubModel;
  uploads?: UploadModel[];
  needDeposit?: number; // Custom front end only field
  needWeekendPrice?: number; // Custom front end only field
  outstationAllowed?: boolean;
}

export interface OrderBikeModel {
  orderId: number;
  bikeId: number;
  prices: BikePrice;
  deposit: number;
  quantity: number;
}

export interface HubBikeOverrideModel {
  id?: number;
  hubId?: number;
  bikeId?: number;
  hubBikeId?: number;
  prices: BikePrice;
  deposit?: number;
  startDate: number;
  endDate: number;
}

export interface AccessoryModel {
  id: number;
  name: string;
  image: string;
  maxQuantityPerBike: number;
  hubs?: HubModel[];
  order_accessories?: {
    orderId: number,
    accessoryId: number,
    price: number,
    quantity: number,
  },
  hub_accessories?: HubAccessoryModel
}

export interface HubAccessoryModel {
  id: number;
  hubId: number;
  accessoryId: number;
  availability: AccessoryAvailability;
  prices: AccessoryPrice;
}

export interface UserModel {
  id: number;
  firstName: string;
  lastName: string;
  countryCode: string;
  phone: string;
  otherPhone?: string;
  email?: string;
  address?: string;
  reputeUrl?: string;
  reputeAttributes?: ReputeAttributes;
  reputeAadhar?: string;
  reputeDl?: string;
  confirmedOrders?: number;
  vendorStats?: {
    lifetimeRevenue: number;
    totalRentalDays: number;
    totalConfirmedOrders: number;
  };
}

export interface UploadModel {
  id: number;
  userId?: number;
  vendorId?: number;
  adminId?: number;
  orderId?: number;
  hubBikeId?: number;
  cityId?: number;
  name: string;
  label?: string;
  ownerType: string;
  category: string;
  adminApproved?: boolean;
  awsKey: string;
  fileType: UploadFileType;
  public: boolean;
  publicUrl?: string;
}

export interface OrderModel {
  id: number;
  userId: number;
  hubId: number;
  vendorId: number;
  couponId?: number;
  orderMode: OrderMode;
  orderTrail: {
    eventType: OrderEvent;
    time: number;
    value?: string;
    comment?: string;
    user?: string;
    customFields?: { [k in CustomTrailFields]: string };
  }[];
  bookingStatus: BookingStatus;
  rideStatus: RideStatus;
  bookingChannel?: string;
  bookingChannelOther?: string;
  bookingType: BookingType;
  billingCycle?: BillingCycle;
  nextBillingDate?: number;
  outstandingAmount?: number;
  lastExtensionDiscount?: number;
  rideStartScheduled: number;
  rideEndScheduled: number;
  rideEndOriginal?: number;
  rideStartActual?: number;
  rideEndActual?: number;
  bikeDetails?: {
    odStart?: number,
    odEnd?: number,
    rcNumber: string,
    batteryNumber?: string
  }[];
  bikePriceDetails?: {
    mainObject?: boolean,
    price: BikePrice,
    deposit?: number,
    startTime?: number,
    endTime?: number
  }[];
  accessoryPriceDetails?: {
    id: number;
    name: string;
    days: number;
    totalPrice: number;
    quantity: number;
    prices: AccessoryPrice;
    package: AccessoryPricePackages;
    unitName: PricePackageUnits;
    unitPrice: number;
    unitQty: number;
  }[];
  couponDetails?: CouponModel;
  staticData?: OrderStaticData;
  totalRentalAmount: number;
  totalBikeAmount: number;
  totalAccessoryAmount: number;
  kmPackagePriceDetails?: { extraKm: number; charge: number }[];
  vendorRentalAmount: number;
  vendorBikeAmount: number;
  vendorAccessoryAmount: number;
  depositAmount: number;
  discount: number;
  goCoinsUsed: number;
  vendorDiscount: number;
  gobikesDiscount: number;
  defaultDiscount: number;
  couponDiscount: number;
  convFees: number;
  goBikesCommission: number;
  tdrAmount: number;
  vendorAmount: number;
  finalVendorAmount: number;
  deliveryAmount: number;
  totalPayableAmount: number;
  currentTotalPayableAmount: number;
  currentTotalPayableAmountWithoutExt: number;
  amountPayableOnline: number;
  offlineCashAmount: number;
  rideOtp: number;
  vendorOtp: number;
  orderNotes?: {
    time: number;
    message: string;
    userType: 'VENDOR' | 'ADMIN';
  }[];
  emPhone?: string;
  localAddress?: string;
  bookingLocation?: { label: string; lat: number; lng: number };
  photo?: string;
  imageData?: { [k in OrderUploadLabels]?: string };
  extraUploadLabels?: { [OrderUploadLabels.EXTRA_1]?: string; [OrderUploadLabels.EXTRA_2]?: string };
  deliveryDetails: {
    required: boolean,
    address?: string,
    pin?: string
  };
  vendorRemark?: string;
  adminRemark?: string;
  cfOrderId?: string;
  cfOrderToken?: string;
  paymentDone: boolean;
  paymentMode: PaymentMode;
  paymentCollected: boolean;
  paymentUrl?: string;
  paymentTime?: number;
  settlementStatus?: SettlementStatus;
  settlementTime?: number;
  payments?: CashfreePayment[];
  refunds?: CashfreeRefund[];
  refundStatus?: OrderRefundStatus | null;
  refundAmounts?: OrderRefundAmounts;
  cancelDetails?: OrderCancelDetails;
  reviews?: ReviewModel[];
  rating?: string;
  user?: UserModel;
  hub?: HubModel;
  bikes?: BikeModel[];
  accessories?: AccessoryModel[];
  order_extensions?: OrderExtensionModel[];
  subscription_invoices?: SubscriptionInvoiceModel[];
  images?: UploadModel[];
  createdAt: string;
  bikeUpdateDetails?: {
    oldBikePayableAmount?: number,
    newBikePayableAmount?: number,
    prevTotalPayableAmount: number,
    newPayableAmount: number,
    bikeDetails?: BikeDetail[]
  }[];
}

export interface OrderExtensionModel {
  id?: number;
  orderId: number;
  extStart: number;
  extEnd: number;
  extraAmount: number;
  paymentLinkId: string;
  paymentLink: string;
  paymentDone: boolean;
  voided?: boolean;
  paymentTime?: number;
  referenceId?: string;
  txStatus?: string;
  paymentMode?: string;
  txMsg?: string;
  txTime?: string;
  signature?: string;
  createdAt?: string;
}

export interface SubscriptionInvoiceModel {
  id?: number;
  orderId: number;
  cycleStart: number;
  cycleEnd: number;
  dueDate: number;
  amount: number;
  status: SubscriptionInvoiceStatus;
  paymentLink?: string;
  paymentLinkId?: string;
  paidAt?: number;
  generatedBy: 'CRON' | 'MANUAL';
  createdAt?: string;
}

export interface ReviewModel {
  overallRating?: number;
  valueForMoney?: number;
  cleanliness?: number;
  rentalDeskService?: number;
  pickupProcess?: number;
  dropProcess?: number;
  message?: string;
  photo?: string;
  vendorReply?: string;
  id?: number;
  userId: number;
  orderId: number;
  hubId: number;
  vendorId: number;
  state: ReviewStates;
  user?: UserModel;
  hub?: HubModel;
  vendor?: VendorModel;
  createdAt: string;
  updatedAt?: string;
}

export interface BlockModel {
  id?: number;
  hubId?: number;
  bikeId?: number;
  quantity: number;
  blockStart: number;
  blockEnd: number;
  hub?: HubModel;
  bike?: BikeModel;
  createdAt?: string;
  updatedAt?: string;
  availableQuantity?: number;
}

export interface LedgerModel {
  id?: number;
  vendorId?: number;
  adjustmentType: LedgerType;
  settlement?: CashfreeVendorLedger;
  adjustment?: CronTaskModel;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface CashfreeVendorSettlementComponent {
  amount: number;
  settlement_eligibility_time: string,
  merchant_order_id: string,
  tx_time: string,
  settlement_id: number,
  settled: boolean,
  fee: string,
  tax: string,
  entity_id: string,
  type: string,
  merchant_vendor_id: string,
  added_on_time: string,
  settlement_time: string,
  settlement_utr: string,
  currency: string,
  debit: string,
  credit: string,
  refund_arn: string,
  // Augmented properties
  orderExtDetails?: {
    orderId: number
  }
  orderCustomPaymentDetails?: {
    orderId: number
  }
}

export interface CronTaskModel {
  id?: number;
  orderId?: number;
  vendorId?: number;
  taskType: CronTaskType;
  refId: string;
  value1: number;
  value2?: number;
  status: CronTaskStatus;
  creationTime: number;
  startTime?: number;
  endTime?: number;
  order?: OrderModel;
  vendor?: VendorModel;
  createdAt?: Date;
  updatedAt?: Date;
}